// src/components/room/RoomVideoSection.jsx
import React from 'react';
import CustomVideoPlayer from '../CustomVideoPlayer';

export default function RoomVideoSection({ fileName, isFullscreen, videoRef, onFileChange, onFullscreenToggle }) {
  return (
    <div className="video-section">
      <div className="video-container">
        {!isFullscreen && (
          <div className="video-info-bar">
            {fileName ? (
              <><span className="file-name">📹 {fileName}</span><label className="btn btn-small btn-outline">Change Video<input type="file" accept="video/*" onChange={onFileChange} style={{display:'none'}}/></label></>
            ) : <span className="file-name" style={{opacity:0.5}}>No video selected</span>}
          </div>
        )}
        <div className="video-wrapper">
          <div style={{display:fileName?'block':'none',width:'100%',height:'100%'}}>
            <CustomVideoPlayer videoRef={videoRef} fileName={fileName} isFullscreen={isFullscreen} onFullscreenToggle={onFullscreenToggle} />
          </div>
          {!fileName && (
            <div className="upload-placeholder">
              <span className="upload-icon">📁</span>
              <p>Choose a video to start watching together</p>
              <label className="btn btn-primary"><span className="btn-icon">📂</span>Choose Video<input type="file" accept="video/*" onChange={onFileChange} style={{display:'none'}}/></label>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}